import React, { useEffect, useRef, useState } from 'react';
import { Alert, Modal, message } from 'antd';
import { orderStatusUpdateApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { canResetOrder } from '../utils/orderPresentation';

const BatchOrderResetFixed = ({
  visible,
  onClose,
  onSuccess,
  selectedOrders = [],
}) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const submitting = useRef(false);
  const validOrders = selectedOrders.filter(canResetOrder);
  useEffect(() => {
    if (visible) setError('');
  }, [visible]);
  const submit = async () => {
    if (submitting.current || !validOrders.length) return;
    submitting.current = true;
    setLoading(true);
    setError('');
    try {
      const response = await orderStatusUpdateApi.batchResetToPendingReview(
        user?.username,
        validOrders.map((order) => order.id),
      );
      if (response.data?.code !== 200)
        throw new Error(response.data?.message || '重置失败');
      message.success('重置请求已完成，正在刷新订单');
      onSuccess();
    } catch (failure) {
      setError(failure.message || '重置结果未确认，请刷新订单后核对。');
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return (
    <Modal
      title="重置异常订单"
      open={visible}
      onOk={submit}
      onCancel={() => {
        if (!loading) onClose();
      }}
      okText={'重置 ' + validOrders.length + ' 项'}
      cancelText="取消"
      confirmLoading={loading}
      okButtonProps={{ disabled: !validOrders.length }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <p className="muted">
        将处理失败且物流待同步或尚无物流状态的订单重置为待审核。重置操作不扣除或恢复积分。
      </p>
      <dl className="batch-summary">
        <dt>已选择</dt>
        <dd>{selectedOrders.length} 项</dd>
        <dt>可重置</dt>
        <dd>{validOrders.length} 项</dd>
        <dt>跳过其他状态</dt>
        <dd>{selectedOrders.length - validOrders.length} 项</dd>
      </dl>
      {!validOrders.length && (
        <Alert type="info" showIcon message="所选订单均不符合重置条件。" />
      )}
      {error && (
        <Alert
          type="error"
          showIcon
          message={error}
          description="请先刷新并核对订单状态，再决定是否重新提交。"
        />
      )}
    </Modal>
  );
};
export default BatchOrderResetFixed;
